/* eslint-disable complexity */
/* eslint-disable max-statements */
import {
   MedicalDeviceOrder,
   MedicalDeviceOrderUpdateCommand,
   MedicalDevicePlacement,
} from '@dreryk/egabinet-ezwm-frontend-api';

import { Choice } from '@dreryk/watermelon';
import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';

import { ExtendedByVisitDocumentExternalId } from '../../../common/visitDocument/VisitDocumentContext.types';

import { MedicalDeviceOrderAllFieldsFormBean } from './medicalDeviceOrder.types';

export const useMedicalDeviceOrderUpdateCommand = (): UseCqrsCommandResult<
   MedicalDeviceOrder,
   ExtendedByVisitDocumentExternalId<MedicalDeviceOrderAllFieldsFormBean>
> => {
   return useCqrsCommand(({ data: formData, externalId }) => {
      let payloadPlacement = null;
      const { placement } = formData;
      if (placement) {
         const [firstPlacement] = placement;
         payloadPlacement = (placement.length === 1 ? firstPlacement ?? null : 'BOTH') as MedicalDevicePlacement | null;
      }

      const command = new MedicalDeviceOrderUpdateCommand();

      command.externalId = externalId;
      command.medicalDeviceId = Choice.withUseDefaultIfNull(formData.device?.id ?? null);
      command.continuation = Choice.withUseDefaultIfNull(formData.continuation ?? null);
      command.itemsCount = Choice.withUseDefaultIfNull(formData.itemsCount ?? null);
      command.awardCriteriaIds = Choice.withUseDefaultIfNull(formData.deviceAwardCriteria?.map(({ id }) => id) ?? []);
      command.diseaseIcd10Code = Choice.withUseDefaultIfNull(formData.disease?.icd10Code ?? null);
      command.firstSupplyDate = Choice.withUseDefaultIfNull(formData.firstSupplyMonth ?? null);
      command.diseaseIcd10Name = Choice.withUseDefaultIfNull(formData.disease?.name ?? null);
      command.fistulaCount = Choice.withUseDefaultIfNull(formData.fistulaCount ?? null);
      command.itemsPerMonthCount = Choice.withUseDefaultIfNull(formData.itemsPerMonthCount ?? null);
      command.placement = Choice.withUseDefaultIfNull(payloadPlacement);
      command.pregnant = Choice.withUseDefaultIfNull(formData.pregnant ?? null);
      command.shorteningDeviceUseTimeSpan = Choice.withUseDefaultIfNull(
         formData.additionalIndications ? formData.additionalIndications.at(0) === 'shorteningDeviceUseTimeSpan' : null
      );
      command.shorteningDeviceUseTimeSpanReasonDescription = Choice.withUseDefaultIfNull(
         !formData.shorteningDeviceUseTimeSpanJustification ||
            formData.shorteningDeviceUseTimeSpanJustification.length === 0
            ? null
            : formData.shorteningDeviceUseTimeSpanJustification
      );
      command.useTimeSpanShorteningForChildrenReason = Choice.withUseDefaultIfNull(
         formData.shorteningDeviceUseTimeSpanReason ?? null
      );
      command.supplyMonthsCount = Choice.withUseDefaultIfNull(formData.supplyMonthsCount ?? null);
      command.fistulaType = Choice.withUseDefaultIfNull(formData.fistulaType ?? null);
      command.refundLimitMultiplicity = Choice.withUseDefaultIfNull(formData.refundLimitMultiplicity ?? null);
      command.additionalInformation = Choice.withUseDefaultIfNull(formData.additionalInformation ?? null);
      return command;
   });
};
